/**
 * 鸡 game manager
 */
export default class ChickGameManager{



}
